import { frontendURL } from '../../../helper/URLHelper';
import MercadoHost from '../mercado/MercadoHost.vue';
import {
  LAIS_CAPTACAO_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/mercado'),
    name: 'mercado_index',
    redirect: laisCanonicalRedirect('pending_market_updates_index'),
    meta: { permissions: LAIS_CAPTACAO_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/mercado/pendentes'),
    alias: [
      frontendURL('accounts/:accountId/pendentes'),
      frontendURL('accounts/:accountId/pending-market-updates'),
      frontendURL('accounts/:accountId/laudos/pendentes'),
    ],
    name: 'pending_market_updates_index',
    component: MercadoHost,
    meta: { permissions: LAIS_CAPTACAO_PERMISSIONS },
  },
];
